import { putRequest } from 'utils/api/apiRequest'

export const putVoucherStatus = (token: string) => putRequest(`/vouchers/${token}/downloaded`, null)
